import { collection, doc, getDoc, onSnapshot, query, where, type Firestore } from 'firebase/firestore'
import { firestoreDb } from './firebase'
import type { TimelineElement } from '../types/timelineElement'
import { scopedReadConstraints } from './accessScopeService'

export const getTimelineElement = async (
  elementId: string,
  db: Firestore = firestoreDb,
): Promise<TimelineElement | null> => {
  if (!elementId) return null
  const snapshot = await getDoc(doc(db, 'elements', elementId))
  return snapshot.exists() ? ({ id: snapshot.id, ...snapshot.data() } as TimelineElement) : null
}

export const subscribeTimelineElements = (
  workspaceId: string,
  onData: (elements: TimelineElement[]) => void,
  onError?: (error: Error) => void,
  db: Firestore = firestoreDb,
) => {
  if (!workspaceId) {
    onData([])
    return () => {}
  }
  try {
    const q = query(
      collection(db, 'elements'),
      where('workspaceId', '==', workspaceId),
      ...scopedReadConstraints(workspaceId),
    )
    return onSnapshot(
      q,
      (snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() } as TimelineElement))
        onData(list)
      },
      (err) => {
        console.warn('[subscribeTimelineElements] subscription error', err)
        onError?.(err)
      },
    )
  } catch (err) {
    console.warn('[subscribeTimelineElements] initialization failed', err)
    return () => {}
  }
}
